<div class="warp-tooltip">

  <div cdkDrag cdkDragPreviewClass="selected" class="item">
    <div class="inner-item">
      <img src="/assets/images/types/{{question.type.image}}" />
      <p class="txt">{{question.titleToData}}</p>
    </div>
    <div class="add-img">
      <img src="/assets/images/question-menu/plus.svg" (click)="addItemToBoard()" class="add-button" />
    </div>
  </div>
  <div class="tooltip-abs">
    <p>{{question.titleToData}}</p>
  </div>
</div>